function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgNoImg = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 1,
  height: 1,
  ref: ref,
  "aria-labelledby": titleId
}, props));

const ForwardRef = /*#__PURE__*/forwardRef(SvgNoImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-img.36371bad3e67d7ef6d41557a4d5158ce.svg";